var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720.742,
    height: 691.27,
    viewBox: "0 0 720.742 691.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emptyData",
    transform: "translate(108.528 63.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 354.5,
    cy: 339.5,
    rx: 354.5,
    ry: 339.5,
    transform: "matrix(1, -0.017, 0.017, 1, -108.528, -50.667)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M415.605,104.047H96.4a7.5,7.5,0,0,0,0,15H415.6a7.5,7.5,0,0,0,0-15Z",
    fill: "#be964d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M415.605,71.722H96.4a7.5,7.5,0,0,0,0,15H415.6a7.5,7.5,0,0,0,0-15Z",
    fill: "#be964d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M415.605,136.372H96.4a7.5,7.5,0,0,0,0,15H415.606a7.5,7.5,0,1,0,0-15Z",
    fill: "#be964d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M256,54.4h99a7.5,7.5,0,0,0,0-15H157a7.5,7.5,0,0,0,0,15Z",
    fill: "#be964d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M345.957,252.492a96.349,96.349,0,1,0,0,136.322,96.506,96.506,0,0,0,0-136.322ZM335.35,378.208a81.357,81.357,0,1,1,0-115.11,81.488,81.488,0,0,1,0,115.11Z",
    fill: "#be964d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M504.5,316.08a7.5,7.5,0,0,0,7.5-7.5V256a7.5,7.5,0,0,0-3.152-6.111L456.441,212.6V111.5a7.5,7.5,0,1,0-15,0V283.257L405.347,303.8a128.653,128.653,0,0,0-255.988,24.3l-78.8-44.844V15H441.44V76.5a7.5,7.5,0,0,0,15,0V7.5a7.5,7.5,0,0,0-7.5-7.5H63.06a7.5,7.5,0,0,0-7.5,7.5V212.6L3.152,249.889A7.5,7.5,0,0,0,0,256V421.11a7.5,7.5,0,1,0,15,0V268.9l136.8,77.85A128.809,128.809,0,0,0,338.073,434.4l21.562,21.562a7.5,7.5,0,0,0,10.608,0l3.268-3.268L388.618,467.8l-3.268,3.268a7.5,7.5,0,0,0,0,10.606L400.678,497H15V456.11a7.5,7.5,0,0,0-15,0V504.5A7.5,7.5,0,0,0,7.5,512h497a7.5,7.5,0,0,0,7.5-7.5V343.58a7.5,7.5,0,0,0-15,0V486.393l-58.186-58.185a7.5,7.5,0,0,0-10.607,0l-3.268,3.268-15.108-15.107L413.1,413.1a7.5,7.5,0,0,0,0-10.606l-21.562-21.561a128.885,128.885,0,0,0,14.914-60.5L497,268.9V308.58a7.5,7.5,0,0,0,7.5,7.5ZM55.56,274.721,21.427,255.3,55.56,231.011ZM197.383,401.065a113.72,113.72,0,1,1,160.824,0,113.849,113.849,0,0,1-160.824,0ZM486.393,497h-64.5L401.26,476.369l32.251-32.251Zm-72.06-54.917-15.108,15.108-15.107-15.108,15.107-15.107ZM397.19,407.8l-32.251,32.251-13.682-13.682a129.5,129.5,0,0,0,32.251-32.251Zm59.25-176.785L490.573,255.3,456.44,274.721Z",
    fill: "#be964d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8b2677a0f55e6fe13096b3df853fb22c.svg";
export { ForwardRef as ReactComponent };